<template>
  <div class="view-wrapper">
    <div class="view">
      <v-card>
        <v-card-title style="padding: 4px 16px">
          <h6>Фильтр</h6>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.from"
                  label="С"
                  type="date"
                  required
                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.to"
                  label="По"
                  type="date"
                  required
                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="filter.wholeFamily"
                  :label="'Вся семья'"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.cardNo"
                  label="Номер карты"
                  clearable
                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="fetchItems">
            Применить
          </v-btn>
          <v-btn small @click="resetFilter">
            Сбросить
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            :loading="exporting"
            :disabled="items.length === 0"
            small
            class="white--text"
            @click="exp"
          >
            Экспорт
            <v-icon right dark>
              cloud_download
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
      >
        <template v-slot:item.visitDateLocal="{ item }">
          <span>{{ item.visitDateLocal | dateLocalFilter }}</span>
        </template>
        <template v-slot:item.postingDateLocal="{ item }">
          <span>{{ item.postingDateLocal | dateLocalFilter }}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import ctx from "@/ctx";
import fetch from "@/utils/fetch";
import js2vm from "@/utils/js2vm";
import dateIsoFilter from "@/filters/dateIso.filter";
import vm2js from "@/utils/vm2js";

let Filter = function() {
  let self = this;

  let from = new Date();
  from.setDate(from.getDate() - 30);
  self.from = dateIsoFilter(from);
  self.to = dateIsoFilter(new Date());
  self.wholeFamily = false;
  self.reserve = false;
  self.cardNo = undefined;
  self.insuranceAmount = undefined;
};

let Item = function(d) {
  let self = this;

  d.card_no = d.cardNo;
  d.person = d.personName;
  d.postingDateLocal = d.postingDate;
  d.visitDateLocal = d.visitDate;
  d.Amount = d.amount;
  d.discount_percent = d.discountPercent;
  d.discounted_amount = d.discountedAmount;
  d.invoice_number = d.invoiceNumber;
  d.organization = d.organizationId;
  d.serviceCategory = d.serviceCategoryId;
  d.service = d.serviceId;
  d.diagnosis = d.diagnosisId;


  self.organization2vm = function(val) {
    if (!val) return {};
    let org = ctx.src.org.first(val);
    if (org.cityKey) org.city = ctx.src.dict["INS_CITY"].get(org.cityKey).value;
    return org;
  };
  self.underwriter2vm = function(val) {
    if (!val) return {};
    return ctx.src.org.first(val);
  };
  self.clientOrganization2vm = function(val) {
    if (!val) return {};
    return ctx.src.org.first(val);
  };

  self.serviceCategory2vm = function(val) {
    if (!val) return {};
    return ctx.src.categories.get(val);
  };

  self.service2vm = function(val) {
    if (!val) return {};
    return ctx.src.services.get(val);
  };

  self.diagnosis2vm = function(val) {
      if (!val) return {};
      return ctx.src.diagnosis.get(val) || {};
  };

  js2vm(self, d);
};

let Report = function(d) {
  let self = this;

  self.title = d.title;
  self.subtitle = d.subtitle;
  self.rows = [];

  d.rows.forEach(i => {
    self.rows.push(new Item(i));
  });
};

export default {
  data: () => ({
    ctx,
    selected: [],
    loading: false,
    headers: [
      {
        text: "№ карты",
        align: "start",
        sortable: false,
        value: "card_no"
      },
      {
        text: "ФИО",
        sortable: false,
        value: "person"
      },
      {
        text: "Дата проведения",
        sortable: false,
        value: "postingDateLocal"
      },
      {
        text: "Дата визита",
        sortable: false,
        value: "visitDateLocal"
      },
      {
        text: "Счет",
        sortable: false,
        value: "invoice_number"
      },
      {
        text: "Компания",
        sortable: false,
        value: "organization.fullName"
      },
      {
        text: "Категория",
        sortable: false,
        value: "serviceCategory.name"
      },
      {
        text: "Мед. услуга",
        sortable: false,
        value: "service.name"
      },
      {
        text: "Диагноз",
        sortable: false,
        value: "diagnosis.label"
      },
      {
        text: "Сумма",
        sortable: false,
        value: "Amount"
      },
      {
        text: "Сумма total",
        sortable: false,
        value: "insuranceAmount"
      },

      {
        text: "Нагрузка, %",
        sortable: false,
        value: "increase"
      }
    ],
    report: {},
    filter: new Filter(),
    items: [],
    exporting: false
  }),
  methods: {
    resetFilter() {
      this.filter = new Filter();
    },
    async exp() {
      this.exporting = true;
      try {
        const res = await fetch.post(
          "/api/report/by-insured/export",
          vm2js(this.report)
        );
        if (res) {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(await res.blob);
          link.download = res.filename;
          link.click();
        }
      } finally {
        this.exporting = false;
      }
    },
    async fetchItems() {
      this.loading = true;
      this.items = [];
      try {
        let res = await fetch.post(
          "/api/report/by-insured/get",
          vm2js(this.filter)
        );
        if (res) {
          this.report = new Report(res);
          res.rows.forEach(r => {
            this.items.push(new Item(r));
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
